import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiKey } from "../../../config/config";
import { toast } from "react-toastify";

function AddCustomerForm() {
  // const {id} = useParams();
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    customer_vat: "",
    dateOfBirth: "",
    dateOfAnniversary: "",
    address: "",
    password: "",
    isCompanyEmployer: 0,
    company_name: "",
    employe_card_no: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    axios
      .post(`${apiKey}/api/rms/admin/customer`, formData, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        toast.success("Success", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      })
      .catch((err) => {
        Object.keys(err.response.data.data).forEach((item) => {
          err.response.data.data[item].forEach((i) => {
            toast.error(i || "Validation Error");
          });
        });
      });
  };

  // useEffect(() => {
  //   if (id) {
  //     axios.get(`${apiKey}`)
  //   }
  // })
  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-d-bg-text text-2xl"> Add Customer</h1>
          </div>
        </div>
        <div className="w-full">
          <form className="w-full" onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-x-8 gap-y-2 w-full ">
              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  Customer Name
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="Customer Name"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required
                    name="name"
                    onChange={handleChange}
                    value={formData.name}
                  />
                </div>
              </label>

              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  Phone
                </span>{" "}
                <span className="ml-1 text-slate-500	text-xs">
                  Should contain country code
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="Phone"
                    className=" px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full "
                    required
                    name="phone"
                    onChange={handleChange}
                    value={formData.phone}
                  />
                </div>
              </label>

              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  Email
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="admin@gmail.com"
                    className=" px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full "
                    required
                    name="email"
                    onChange={handleChange}
                    value={formData.email}
                  />
                </div>
              </label>
              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2  font-bold">
                  Customer Vat No
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="Customer Vat No"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required
                    name="customer_vat"
                    onChange={handleChange}
                    value={formData.customer_vat}
                  />
                </div>
              </label>

              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2  font-bold">
                  Date Of Birth
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="date"
                    placeholder="Date Of Birth"
                    className=" px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full "
                    required
                    name="dateOfBirth"
                    onChange={handleChange}
                    value={formData.dateOfBirth}
                  />
                </div>
              </label>

              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 font-bold">
                  Date Of Anniversary
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="date"
                    placeholder="Date Of Anniversary"
                    className=" px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full "
                    defaultValue={new Date().toISOString().split("T")[0]}
                    disabled
                  />
                </div>
              </label>

              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2  font-bold">
                  Address
                </span>
                <div className="mb-2 pt-0 ">
                  <textarea
                    rows="3"
                    type="text"
                    placeholder="Address"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required
                    name="address"
                    onChange={handleChange}
                    value={formData.address}
                  />
                </div>
              </label>

              <label htmlFor="" className="">
                <span className="text-d-bg-text text-sm mb-2  font-bold">
                  Password
                </span>
                <div className="mb-2 pt-0 pr-1">
                  <input
                    type="text"
                    placeholder="*******"
                    className=" px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full "
                    required
                    name="password"
                    onChange={handleChange}
                    value={formData.password}
                  />
                </div>
              </label>

              <label htmlFor="" className="">
                <span className="text-d-bg-text text-sm mb-2 font-bold">
                  Is Company Employer
                </span>
                <div className="mb-2 pt-0 flex gap-1">
                  <input
                    onChange={handleChange}
                    className="form-check-input px-2 py-3"
                    type="radio"
                    name="isCompanyEmployer"
                    id="exampleRadios1"
                    value={1}
                    checked={formData.isCompanyEmployer === 1}
                  />
                  <label className="form-check-label" htmlFor="exampleRadios1">
                    Yes
                  </label>
                  <input
                    onChange={handleChange}
                    className="form-check-input ml-2"
                    type="radio"
                    name="isCompanyEmployer"
                    id="exampleRadios2"
                    value={0}
                    checked={formData.isCompanyEmployer === 0}
                  />
                  <label className="form-check-label" htmlFor="exampleRadios2">
                    No
                  </label>
                </div>
              </label>
              {formData.isCompanyEmployer === "yes" && (
                <>
                  <label htmlFor="">
                    <span className="text-d-bg-text text-sm mb-2  font-bold">
                      Company Name
                    </span>
                    <div className="mb-2 pt-0">
                      <input
                        type="text"
                        placeholder="Company Name"
                        className=" px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full "
                        name="company_name"
                        onChange={handleChange}
                        value={formData.company_name}
                      />
                    </div>
                  </label>

                  <label htmlFor="">
                    <span className="text-d-bg-text text-sm mb-2 font-bold">
                      Employee Card No
                    </span>
                    <div className="mb-2 pt-0">
                      <input
                        type="text"
                        placeholder="Employee Card No"
                        className=" px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full "
                        name="employe_card_no"
                        onChange={handleChange}
                        value={formData.employe_card_no}
                      />
                    </div>
                  </label>
                </>
              )}
            </div>
            <span className="w-full bg-d-bg h-1 my-2 inline-block"></span>
            <div className="flex gap-2">
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="submit"
              >
                Submit
              </button>
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="button"
                onClick={() => navigate(-1)}
              >
                Back
              </button>
            </div>
          </form>
        </div>
      </div>
    </main>
  );
}

export default AddCustomerForm;
